export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'та',
'_.loadingSpinnerText': 'Будь ласка, зачекайте...',
'pageTimerMax.text': 'Після закінчення часу ви автоматично перейдете на наступну сторінку.',
'pageTimerMax.timeLeft': 'Час, що залишився',
'pageTimerMin.text': 'Немає можливості перейти далі до закінчення часу.',
'pageTimerMin.timeLeft': 'Час, що залишився',
'pageTimerMin.allowNext': 'Ви можете перейти далі',
'survey.registerForm.label.email': 'Електронна пошта',
'survey.registerForm.label.newsletter': 'Я хочу отримувати розсилку матеріалів',
'survey.registerForm.label.regulations': 'Я приймаю політику, положення та умови',
'survey.registerForm.button.register': 'Зареєструватися',
'survey.registerForm.registered': 'Дякуємо за реєстрацію. на вказану електронну адресу надіслано лист із посиланням для підтвердження реєстрації',
'survey.registerForm.cardHeader': 'Реєструйтеся та отримуйте бали!',
'survey.registerForm.cardBody': 'за заповнення анкети ви отримали',
'survey.registerForm.cardBody2': 'Бали будуть зараховані вам після того, як ви зареєструєте обліковий запис на swpanel.co.uk. Введіть свою електронну адресу та зареєструйте обліковий запис на swpanel.pl',
'survey.notProperDevice': 'На жаль, ви не можете пройти це опитування на цьому пристрої.',
'survey.properDevices': 'Доступ до анкети можна отримати з наступних пристроїв:',
'survey.device-phone': 'смартфон',
'survey.device-tablet': 'планшет',
'survey.device-desktop': 'комп\'ютер / ноутбук',
'nextSurveys.header.seeAlso': 'Дивіться також інші опитування',
'nextSurveys.button.fill': 'Заповнити',
'question.noContent': 'Відсутній зміст питання',
'question.input.placeholder.typeYourAnswer': 'Введіть свою відповідь',

'question.conjoint.go': 'Натисніть кнопку "Далі"',
'question.matrix.carousel.go': 'Натисніть кнопку "Далі"',
'question.carousel.prevBtn': 'Попереднє твердження',
'question.carousel.nextBtn': 'Наступне твердження',

'question.open.email.inputPlaceholder': 'Введіть адресу електронної пошти',
'question.open.email.emailVerify.sendCode': 'Надіслати код підтвердження',
'question.open.email.emailVerify.enderCode': 'Введіть отриманий код',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Введіть код',
'question.open.email.emailVerify.confirm': 'Підтвердити',
'question.open.email.emailVerify.codeIncorrect': 'Ви ввели невірний код',
'question.open.email.emailVerify.codeCorrect': 'Адреса електронної пошти перевірена правильно',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Заповнення паузи',
'footer.buttonPrev.text': 'Скасувати',
'footer.buttonClear.text': 'Очистити',
'footer.buttonNext.text': 'Далі',
'footer.buttonEnd.text': 'Закінчити',
'footer.buttonStart.text': 'Почати опитування',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
